function toggleCustomCollapse(element) {
	var container = element.closest('.custom-collapse--container');
	var content = container.querySelector('.custom-collapse--content');
	var sectionContainer = element.closest('ul');
	if (container.classList.contains('open') == false) {
		if (sectionContainer.querySelector('.custom-collapse--container.open')) {
			sectionContainer.querySelector('.custom-collapse--container.open .custom-collapse--content').style.maxHeight = 0;
			sectionContainer.querySelector('.custom-collapse--container.open').classList.remove('open');
		}
		container.classList.add('open');
		content.style.maxHeight = content.scrollHeight + 'px';
	} else {
		container.classList.remove('open');
		content.style.maxHeight = 0;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	Array.from(document.querySelectorAll('.custom-product-images li')).forEach((element) => {
		element.addEventListener('click', () => {
			element.closest('.product-images').querySelector('.custom-product-featured-image.active').classList.remove('active');
			element.closest('.product-images').querySelector('.custom-product-images li.active').classList.remove('active');
			element.closest('.product-images').querySelector('.custom-product-featured-image[data-id="'+element.getAttribute('target-id')+'"]').classList.add('active');
			element.classList.add('active');
		});
	});
	if (document.querySelector('.product-images-container ul') != null) {
		if (document.querySelector('.product-images-container ul').clientWidth == document.querySelector('.product-images-container ul').scrollWidth) {
			Array.from(document.querySelectorAll('.product-images-container > span')).forEach((element) => {
				element.style.display = 'none';
			});
		}
	}
	Array.from(document.querySelectorAll('.product-images-container > span.next')).forEach((element) => {
		element.addEventListener('click', () => {
			var scrollContainer = document.querySelector('.product-images-container').querySelector('.custom-product-images');
			scrollContainer.scrollTo(scrollContainer.scrollLeft + document.querySelector('.product-images-container li').clientWidth, 0);
		});
	});
	Array.from(document.querySelectorAll('.product-images-container > span.prev')).forEach((element) => {
		element.addEventListener('click', () => {
			var scrollContainer = document.querySelector('.product-images-container').querySelector('.custom-product-images');
			scrollContainer.scrollTo(scrollContainer.scrollLeft - document.querySelector('.product-images-container li').clientWidth, 0);
		});
	});

	
	Array.from(document.querySelectorAll('.custom-video-products--menu-list li')).forEach((element) => {
		element.addEventListener('click', () => {
			var container = element.closest('.section--custom-video-products--container');
			container.querySelector('.custom-video-products--content-list li.active').classList.remove('active');
			container.querySelector('.custom-video-products--menu-list li.active').classList.remove('active');
			element.classList.add('active');
			container.querySelector('.custom-video-products--content-list li[data-id="'+element.getAttribute('target-id')+'"]').classList.add('active');
		});
	});
	Array.from(document.querySelectorAll('.video-icon.play')).forEach((element) => {
		element.addEventListener('click', () => {
			element.closest('.video-container').querySelector('video').play();
			element.closest('.video-container').classList.add('playing');
			element.closest('.video-container').querySelector('.video-icon.pause').classList.add('active');
			element.classList.remove('active');
		});
	});
	Array.from(document.querySelectorAll('.video-icon.pause')).forEach((element) => {
		element.addEventListener('click', () => {
			element.closest('.video-container').querySelector('video').pause();
			element.closest('.video-container').classList.remove('playing');
			element.classList.remove('active');
			element.closest('.video-container').querySelector('.video-icon.play').classList.add('active');
		});
	});

	Array.from(document.querySelectorAll('.custom-collapse--header')).forEach((element) => {
		element.addEventListener('click', () => {
			console.log(element);
			toggleCustomCollapse(element)
		});
	});
});